import { select, put } from 'redux-saga/effects';
import { push as navigateTo } from 'connected-react-router';
import { getBuilding } from 'selectors/buildingsSelectors';
import { Building } from 'shared/models';

export function makeNavigateToBuildingRoute(route: string) {
    return function* navigateToBuildingRoute(buildingId: string, orElseRoute: string) {
        const building: Building = yield select(getBuilding, { buildingId });
        if (building) {
            const urlSlug = building.urlSlug;
            yield put(navigateTo(`/buildings/${urlSlug}/${route}`));
        }
        else {
            yield put(navigateTo(orElseRoute));
        }
    };
}
